<template>
  <div class="mt-2">
    <!-- media -->
    <b-media
      no-body
    >
      <b-media-aside class="mr-1">
        <b-avatar
          rounded
          variant="light-primary"
          size="34"
        >
          <feather-icon
            icon="UserIcon"
            size="18"
          />
        </b-avatar>
      </b-media-aside>
      <b-media-body v-if="data.length">
        <h6 class="mb-0">
          {{ titulo }}
        </h6>
        <b-avatar-group
          class="mt-2 pt-50"
          size="50"
        >
          <b-avatar
            v-for="avatar in data"
            :key="`${avatar.titulo}-${avatar.id}`"
            v-b-modal="`${idm}-${avatar.titulo}-${avatar.id}`"
            v-b-tooltip.hover.bottom="avatar.titulo"
            :src="avatar.picprofile ? `${delivery}${avatar.picprofile}` : ''"
            class="pull-up"
          />
        </b-avatar-group>

      </b-media-body>
    </b-media>

  </div>
</template>
<script>
import {
  BMedia, BMediaAside, BMediaBody, BAvatarGroup, BAvatar, VBTooltip,
} from 'bootstrap-vue'

export default {
  components: {

    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatarGroup,
    BAvatar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: [Array, null],
      default: null,
    },
    titulo: {
      type: String,
      default: '',
    },
    idm: {
      type: String,
      default: 'modal',
    },
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      delivery,
    }
  },
}
</script>
